import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useMemo } from "react";

const useStyles = makeStyles({
  root: {
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    overflow: 'hidden'
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  }
});

export const EconomicsProbableReservesDataTable = ({ economics }) => {

  // STYLES
  const classes = useStyles();

  const rows = useMemo(() => {
    try {
      const data = [];
      const types = ['gross', 'companyGross', 'companyNet'];
      const wellType = economics?.economicVolumesGross?.oil > 0 ? 'oil' : 'gas';

      types?.forEach(type => {
        data.push({
          id: type,
          name: formatName(type),
          oil: getVolume('oil', type, wellType),
          heavyOil: 0,
          bitumen: 0,
          tightOil: 0,
          solutionGas: getVolume('solutionGas', type, wellType),
          assGas: getVolume('assGas', type, wellType),
          cbm: 0,
          shaleGas: 0,
          ethane: 0,
          propane: getVolume('propane', type, wellType),
          butane: getVolume('butane', type, wellType),
          pentanes: getVolume('pentanes', type, wellType),
          condensate: getVolume('condensate', type, wellType),
          ngl: getVolume('ngl', type, wellType),
          sulphur: 0,
          boe: getVolume('boe', type, wellType)
        });
      });
      
      return data;

      function formatName(type) {
        switch(type) {
          case 'gross':
            return 'Gross';
          case 'companyGross':
            return 'Company Gross';
          case 'companyNet':
            return 'Company Net';
          default:
            return '';
        };
      };

      function getVolume(fluid, type, wellType) {
        switch(fluid) {
          case 'oil':
            if (type === 'gross') {
              return Number((economics?.economicVolumesGross?.oil / 1000)?.toFixed(2));
            } else if (type === 'companyGross') {
              return Number((economics?.economicVolumesNet?.oil / 1000)?.toFixed(2));
            } else if (type === 'companyNet') {
              return Number((economics?.economicVolumesCompanyNet?.oil / 1000)?.toFixed(2));
            };
            break;
          case 'solutionGas':
            if (wellType === 'oil') {
              if (type === 'gross') {
                return Number((economics?.economicVolumesGross?.salesGas)?.toFixed(2));
              } else if (type === 'companyGross') {
                return Number((economics?.economicVolumesNet?.salesGas)?.toFixed(2));
              } else if (type === 'companyNet') {
                return Number((economics?.economicVolumesCompanyNet?.salesGas)?.toFixed(2));
              };
            } else {
              return 0;
            };
            break;
          case 'assGas':
            if (wellType === 'gas') {
              if (type === 'gross') {
                return Number((economics?.economicVolumesGross?.salesGas)?.toFixed(2));
              } else if (type === 'companyGross') {
                return Number((economics?.economicVolumesNet?.salesGas)?.toFixed(2));
              } else if (type === 'companyNet') {
                return Number((economics?.economicVolumesCompanyNet?.salesGas)?.toFixed(2));
              };
            } else {
              return 0;
            };
            break;
          case 'propane':
            if (type === 'gross') {
              return Number(((economics?.economicVolumesGross?.propane) / 1000)?.toFixed(2));
            } else if (type === 'companyGross') {
              return Number(((economics?.economicVolumesNet?.propane) / 1000)?.toFixed(2));
            } else if (type === 'companyNet') {
              return Number(((economics?.economicVolumesCompanyNet?.propane) / 1000)?.toFixed(2));
            };
            break;
          case 'butane':
            if (type === 'gross') {
              return Number(((economics?.economicVolumesGross?.butane) / 1000)?.toFixed(2));
            } else if (type === 'companyGross') {
              return Number(((economics?.economicVolumesNet?.butane) / 1000)?.toFixed(2));
            } else if (type === 'companyNet') {
              return Number(((economics?.economicVolumesCompanyNet?.butane) / 1000)?.toFixed(2));
            };
            break;
          case 'pentanes':
            if (type === 'gross') {
              return Number(((economics?.economicVolumesGross?.pentanes) / 1000)?.toFixed(2));
            } else if (type === 'companyGross') {
              return Number(((economics?.economicVolumesNet?.pentanes) / 1000)?.toFixed(2));
            } else if (type === 'companyNet') {
              return Number(((economics?.economicVolumesCompanyNet?.pentanes) / 1000)?.toFixed(2));
            };
            break;
          case 'condensate':
          if (type === 'gross') {
            return Number((economics?.economicVolumesGross?.condensate / 1000)?.toFixed(2));
          } else if (type === 'companyGross') {
            return Number((economics?.economicVolumesNet?.condensate / 1000)?.toFixed(2));
          } else if (type === 'companyNet') {
            return Number((economics?.economicVolumesCompanyNet?.condensate / 1000)?.toFixed(2));
          };
            break;
          case 'ngl':
            if (type === 'gross') {
              return Number(((economics?.economicVolumesGross?.ngl + economics?.economicVolumesGross?.condensate) / 1000)?.toFixed(2));
            } else if (type === 'companyGross') {
              return Number(((economics?.economicVolumesNet?.ngl + economics?.economicVolumesNet?.condensate) / 1000)?.toFixed(2));
            } else if (type === 'companyNet') {
              return Number(((economics?.economicVolumesCompanyNet?.ngl + economics?.economicVolumesCompanyNet?.condensate) / 1000)?.toFixed(2));
            };
            break;
          case 'boe':
            if (type === 'gross') {
              return Number((economics?.cashflowGross?.reduce((prev, curr) => prev + curr.boe, 0) / 1000)?.toFixed(2));
            } else if (type === 'companyGross') {
              return Number((economics?.cashflowNet?.reduce((prev, curr) => prev + curr.boe, 0) / 1000)?.toFixed(2));
            } else if (type === 'companyNet') {
              let volume = economics?.cashflowNet?.reduce((prev, curr) => prev + curr.boe, 0) / 1000;
              volume -= volume * economics?.settings?.royalty;
              return Number(volume?.toFixed(2));
            };
            break;
          
         
          default:
            return 0;
        };
      };

    } catch (error) {
    };
  }, [economics]);

  const columns = useMemo(() => {
    return [
      {
        field: 'name',
        headerName: 'Type',
        width: 120,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false,
        type: 'string'
      },
      {
        field: 'oil',
        headerName: 'Lt. Med. Oil (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'heavyOil',
        headerName: 'Heavy Oil (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'bitumen',
        headerName: 'Bitumen (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'tightOil',
        headerName: 'Tight Oil (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'solutionGas',
        headerName: 'Solution Gas (MMscf)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'assGas',
        headerName: 'Non-Assoc. & Assoc. Gas (MMscf)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'cbm',
        headerName: 'CBM (MMscf)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'shaleGas',
        headerName: 'Shale Gas (MMscf)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'ethane',
        headerName: 'Ethane (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'propane',
        headerName: 'Propane (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'butane',
        headerName: 'Butane (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'pentanes',
        headerName: 'Pentanes+ (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'condensate',
        headerName: 'Condensate (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'ngl',
        headerName: 'NGL Total (Mbbl)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'sulphur',
        headerName: 'Sulphur (MLt)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'boe',
        headerName: 'Equiv. Oil (MBoe)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      }
    ];
  }, []);

  try {

    if (rows) {
      return (
        <div className={classes.root}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[10,25,50,100]}
            disableSelectionOnClick
            className={classes.table}
            components={{
              Toolbar: GridToolbar,
            }}
            sx={{fontSize: 12}}
            rowHeight={24}
            autoHeight={true}
          />
        </div>
      );
    } else {
      return <></>;
    };

  } catch (error) {
    return <></>
  };

};
